<template>
    <div class="info-detail-tip" v-show="isTitleParty">
        <label class="detail-tip" style="visibility:hidden;">标题:</label>
        <span style="color:red; font-size:16px;">标题涉嫌标题党</span>
    </div>
</template>

<script>
export default {
    props: {
        isTitleParty: {
            type: Boolean,
            default: false
        }
    }
};
</script>
